var map = {
	"./BEEExpress": "fa07",
	"./BEEExpress.js": "fa07",
	"./BestExpress": "d120",
	"./BestExpress.js": "d120",
	"./CJLogisticShopX": "08a7",
	"./CJLogisticShopX.js": "08a7",
	"./Courier": "b56a",
	"./Courier.js": "b56a",
	"./DHLExpress": "40f6",
	"./DHLExpress.js": "40f6",
	"./FlashExpress": "308e",
	"./FlashExpress.js": "308e",
	"./FlashExpressWarp": "22cd",
	"./FlashExpressWarp.js": "22cd",
	"./GenCourier": "2889",
	"./GenCourier.js": "2889",
	"./JAndTExpress": "bffc",
	"./JAndTExpress.js": "bffc",
	"./KerryExpress": "46ac",
	"./KerryExpress.js": "46ac",
	"./KerryQuickExpress": "a5a4",
	"./KerryQuickExpress.js": "a5a4",
	"./MakesendExpress": "2a7f",
	"./MakesendExpress.js": "2a7f",
	"./MakesendExpressChilled": "22ae",
	"./MakesendExpressChilled.js": "22ae",
	"./Ninjavan": "5619",
	"./Ninjavan.js": "5619",
	"./SCGCool": "dabf",
	"./SCGCool.js": "dabf",
	"./SCGExpress": "7f73",
	"./SCGExpress.js": "7f73",
	"./SCGFrozen": "689a",
	"./SCGFrozen.js": "689a",
	"./SPGenCourier": "91d2",
	"./SPGenCourier.js": "91d2",
	"./SPRESS": "93c5",
	"./SPRESS.js": "93c5",
	"./STTransport": "9817",
	"./STTransport.js": "9817",
	"./ShippopExpress": "dec3",
	"./ShippopExpress.js": "dec3",
	"./ShippopExpressCool": "22c3",
	"./ShippopExpressCool.js": "22c3",
	"./Teleport": "6507",
	"./Teleport.js": "6507",
	"./Temp": "6d22",
	"./Temp.js": "6d22",
	"./ThailandEcoPost": "8135",
	"./ThailandEcoPost.js": "8135",
	"./ThailandPost": "b98f",
	"./ThailandPost.js": "b98f",
	"./ThailandPost2": "b34e",
	"./ThailandPost2.js": "b34e",
	"./TrueELogistics": "ad07",
	"./TrueELogistics.js": "ad07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6f4";